(function () {
  function fallbackCopy(text) {
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'absolute';
    field.style.left = '-9999px';
    document.body.appendChild(field);
    field.select();
    var copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }
    document.body.removeChild(field);
    return copied;
  }

  function bindShare(root) {
    if (!root || root.dataset.csShareReady === '1') return;
    root.dataset.csShareReady = '1';
    var button = root.querySelector('[data-cs-share-copy]');
    var nativeButtons = root.querySelectorAll('[data-cs-share-native]');
    var status = root.querySelector('[data-cs-share-status]');
    var url = root.getAttribute('data-share-url') || window.location.href;
    var title = root.getAttribute('data-share-title') || document.title;
    var description = root.getAttribute('data-share-description') || '';
    var successText = root.getAttribute('data-copy-success') || 'Link kopiert';

    async function copyUrl() {
      var copied = false;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(url);
          copied = true;
        } catch (error) {
          copied = fallbackCopy(url);
        }
      } else {
        copied = fallbackCopy(url);
      }
      return copied;
    }

    nativeButtons.forEach(function (nativeButton) {
      nativeButton.addEventListener('click', async function () {
        var platform = nativeButton.getAttribute('data-share-platform') || 'die App';
        if (navigator.share) {
          try {
            await navigator.share({ title: title, text: description, url: url });
            if (status) status.textContent = 'Teilen geöffnet';
            return;
          } catch (error) {
            if (error && error.name === 'AbortError') return;
          }
        }

        var copied = await copyUrl();
        if (status) {
          status.textContent = copied ? successText + ' – jetzt in ' + platform + ' einfügen' : '';
        }
      });
    });

    if (!button) return;

    button.addEventListener('click', async function () {
      var copied = await copyUrl();
      if (status) {
        status.textContent = copied ? successText : '';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cs-social-share]').forEach(bindShare);
  });
})();
